<template>
  <div class="component-container">
    <div class="second-edition" id="second-edition">
      <h3>4ENG Second Edition: Processes that Shape the Earth - Downloads and Resources</h3>
      
      <div class="back-button-wrapper">
        <button type="button" @click.prevent="cancelButton" class="back-button">Back to Main Dashboard</button>
      </div>
      <div class="presentations">
        <h4>Teacher Resources</h4>
        <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FAugust%202024%20Updates%2F4ENG-2E_Activities_1-5_08262024.zip?alt=media&token=7fc05da0-cc1e-405a-8b40-aed7077f3e95" target="_blank">Teacher Presentations: Activities 1 - 5</a> - Updated 8/26/2024</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1RZrQWEcgAu2kxE60cdaDCwpFOj35RFvl_ZiPRYWxAXw/edit?usp=sharing" target="_blank">Teacher Guide Links Spreadsheet</a> - List of all links in the printed Teacher Guide</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1qe8R8GD92WO6dtzWri9pKbKWjAYx2siuRzdE8bcT_6c/edit?gid=1062009112#gid=1062009112">Curriculum Updates Spreadsheet </a> - List with links to updates for your printed Teacher Guide</li>
        </ul>
      </div>
      <div class="presentations">
        <h4>Student Journals</h4>
        <p>Please make a master copy for your classroom and save to your Google drive for your classroom.</p>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1wyLBTVF9VW97YO7_urM10Z2LuaNN0InFScjWatGKTnk/copy" target="_blank">4ENG Second Edition: Processes that Shape the Earth Student Journal</a></li>
          <li><a href="https://drive.google.com/file/d/15LjItfLGAEZjjrSkzaVe2OGSebLfFVmg/view" target="_blank">4ENG Second Edition: Processes that Shape the Earth Student Journal Answer Key</a></li>
          <li><a href="https://docs.google.com/presentation/d/1hxBlT7u2pL_bNpQIzIFJL53xyL6ksO7i2attpb0-JBI/copy" target="_blank">4ENG Second Edition: Processes that Shape the Earth Student Journal - SPANISH</a></li>
        </ul>
      </div>
      <div class="presentations">
        <h4>Individual Resources</h4>
        <p>The resources below are also linked in the Teacher Led Presentations. We've provided them here for anyone wishing to have access to these individual resources outside of the presentations. Please make master copies and save in your Google drive for your classroom.</p>
        <h4 style="margin-left: 10px;">Charts, Handouts, Card Sets, etc.</h4>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1FJmSmyel-SaAMnjwb5oyC1QD46h77IUdP5Ax5R2poQE/copy" target="_blank">What We Think Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/1PUbAuw07givyJ-jKWhN0X-50u_sZ_Vc_G4EdiBYsKUo/copy" target="_blank">Weathering and Erosion Card Set</a></li>
          <li><a href="https://docs.google.com/presentation/d/1e9dhObojFH6U0Q0uQt-DPiccFkBfstZTlxx8PjO3N0s/copy" target="_blank">Grand Canyon Picture</a></li>
          <li><a href="https://docs.google.com/presentation/d/1mAXJkpMmexViNqt37sQI17dXAVtOnpdXcmIuJBkujH8/copy" target="_blank">Word Wall</a></li>
          <li><a href="https://docs.google.com/presentation/d/1Q-LDuuWlgyjip_r2mzOuXzBiBjsqs9t4CctR6nI5b5Q/copy" target="_blank">Weathering and Erosion Observation chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/1OVeMg-BzifzwXqw_hBXjz7QA8anVnlE_lll-8DjN7wo/copy" target="_blank">Word Sort Cards</a></li>
          <li><a href="https://docs.google.com/presentation/d/1JDp54KecXUKzDazgUzAibVZGIJi8I3gHNsTzwi-98NU/copy" target="_blank">Chemical Erosion Observation Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/1w7kLMrAyrKAk2HuDHLZtr_HFDXmhJiMEnvOKzwVtLvo/copy" target="_blank">Word Sort Cards</a></li>
          <li><a href="https://docs.google.com/presentation/d/1A553IVmQjQZtB-_56_tu4FrgsBAuqiDQM_r-hwrPw3o/copy" target="_blank">Fossil Pictures</a></li>
          <li><a href="https://docs.google.com/presentation/d/1oIt4lBcAZM3KE7EW88YJZNTuXTXYLF19KJvxFC_yzf4/copy" target="_blank">Word Sort Cards</a></li>
          <li><a href="https://docs.google.com/presentation/d/1ry740aRc9Qc6FFYNYw5VjZdUWFG3PVHXseKzJZ7RgOo/copy" target="_blank">Mapping Earthquakes Handout</a></li>
          <li><a href="https://docs.google.com/presentation/d/1geGvMnu5xHkfSDEvp3PDNaHoVwtPiLlv0jO-KLL9Ghs/copy" target="_blank">Word Sort Cards</a></li>
          <li><a href="https://docs.google.com/presentation/d/1XVz1CHRcLkZ8tKsOLFo4oGNcU11xj5XqkQ3htKomNps/copy" target="_blank">Effects of Natural Hazards</a></li>
          <li><a href="https://docs.google.com/presentation/d/14mNNHHACDWAmG0vfa5vexionDl_ab7Vty8jrRo7I6ZY/copy" target="_blank">Natural Resources for Manufacturing</a></li>
          <li><a href="https://docs.google.com/presentation/d/1b8wgSC-24IbBEkGLRq3mt_PqLDpLSPpSDnMQLNAiN04/copy" target="_blank">Student Classification</a></li>
          <li><a href="https://docs.google.com/presentation/d/1bBztsL6ytamcyhJB6tYVSkoZGZ6s8aeJ5OmChEKQGmg/copy" target="_blank">Class Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/1rVqDd_Ez13axacfZ-Ymr3qdzAr7dtcplt7hmF7kz45Y/copy" target="_blank">Word Sort Cards</a></li>
          <li><a href="https://docs.google.com/presentation/d/1UzQXziA5lpZNNfgUAw1f2AyIZcwvdIKpUhrkP0dk9Bk/copy" target="_blank">Effect on Human Activity cards</a></li>
          <!-- <li><a href="" target="_blank"></a></li> -->

        </ul>
        
      </div>
    </div>
  </div>
  </template>

  <script>
  import { mapState } from 'vuex'

  export default {
  data() {
    return {}
  },
  computed: {
    ...mapState([ 'dashboardView', 'userProfile' ])
  },
  methods: {
    cancelButton() {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
  }
  </script>

  <style lang="css" scoped>
  .presentations {
  border: 1px solid grey;
  text-align: left;
  padding: 20px;
  margin: 0 20px 20px 20px;
  }
  ul {
  list-style: none;
  }
  .presentations a {
  margin-left: 40px;
  }
  li {
  margin-left: -40px;
  }
  .back-button-wrapper {
  width: 100%;
  text-align: left;
  margin-bottom: 0;
  }
  .back-button {
  background: white;
  border: none;
  font-weight: 600;
  color: #7b8a1d;
  margin-left: 20px;
  }
  </style>
